import React, { Component } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import Loader from "./Loader";

class ContactBanner extends Component {
  render() {
    return (
      <Container>
        <MenuLink exact to="/contact">
          {this.props.loading ? <Loader /> : this.props.text}
        </MenuLink>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  background: rgba(253, 186, 3, 0.85);
  text-align: center;
  display: block;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
`;

const MenuLink = styled(NavLink)`
  margin: 0;
  padding: 15px 0 15px 0;
  color: #000000;
  text-transform: uppercase;
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  display: block;
  @media only screen and (max-width: 960px) {
    font-size: 15px;
  }
`;

export default ContactBanner;



// WEBPACK FOOTER //
// ./src/components/ContactBanner.js